export default {
    //apiBaseUrl : "http://localhost:51944/v1/"
    apiBaseUrl: "http://api.dr3.co.uk/v1/"
}